import React, { useState, useRef, useEffect } from "react";
import "./ThreeOptionVerticalSwitch.css";
import Up from "../../images/Up-arrow.svg";
import down from "../../images/Down-arrow.svg";
import startHere from "../../images/Start-here.svg";

const ThreeOptionVerticalSwitch = (props) => {
  const {
    selected,
    setSelectedOptions,
    index,
    setStarthere,
    starthere,
    children,
  } = props;
  const [selectedOption, setSelectedOption] = useState(selected[index]);
  const isDragging = useRef(false); // To track dragging state

  const handleThumbMouseDown = () => {
    isDragging.current = true;
    // console.log("down")
  };

  const handleMouseUp = (event) => {
    if (isDragging.current) {
    // console.log("up")
      isDragging.current = false;

      const boundingBox = event.currentTarget.getBoundingClientRect();
      const clickY = event.clientY - boundingBox.top;
      const switchHeight = boundingBox.height;

      const newPosition = calculateNewPosition(clickY, switchHeight);
      setSelectedOption(newPosition);

      setSelectedOptions((prevSelected) => {
        const newSelected = [...prevSelected];
        newSelected[index] = newPosition;
        return newSelected;
      });
    }
  };

  const handleMouseMove = (event) => {
    if (isDragging.current) {
    // console.log("move")
      const boundingBox = event.currentTarget.getBoundingClientRect();
      const clickY = event.clientY - boundingBox.top;
      const switchHeight = boundingBox.height;
      // setStarthere(false);
      const newPosition = calculateNewPosition(clickY, switchHeight);
      setSelectedOption(newPosition);
    }
  };

  const handleMouseLeave = (event) => {
    handleMouseUp(event)
    isDragging.current = false
    // console.log("leave")
  }

  const calculateNewPosition = (clickY, switchHeight) => {
    if (clickY < switchHeight / 3) {
      return -1;
    } else if (clickY > (2 * switchHeight) / 3) {
      return 1;
    } else {
      return 0;
    }
  };

  return (
    <div className="switch-container">
      {starthere && (
        <div className="start-here animate__animated animate__bounceIn">
          <img src={startHere} alt="startHere" className="imagetag" />
        </div>
      )}
      <div
        className="three-option-vertical-switch-container"
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseDown={handleThumbMouseDown}
        onMouseLeave={handleMouseLeave}
      >
        <label
          className={`switch ${selectedOption === 0 ? "default" : ""} ${
            selectedOption === -1 ? "upper" : ""
          } ${selectedOption === 1 ? "lower" : ""}`}
          onMouseDown={handleThumbMouseDown}
        >
          <div className={`slider mySlider`}></div>
        </label>
      </div>
      {children}
      <div className="arrows">
        {selectedOption === -1 && (
          <img src={Up} alt="up" className="arrowIcon" />
        )}
        {selectedOption === 1 && (
          <img src={down} alt="down" className="arrowIcon" />
        )}
      </div>
    </div>
  );
};

export default ThreeOptionVerticalSwitch;
